// extracted by mini-css-extract-plugin
export default {"flex_center":"layout_flex_center__d71C-","flex_horizontal":"layout_flex_horizontal__qiuR0","half_width":"layout_half_width__ppHQ8"};